import React from "react";
import image from "../../home/imgs/th.jpeg";
import mamakaba from "../../home/imgs/th.jpeg";
import reponse from "../../home/imgs/th.jpeg";

// Sample team member data
const team = [
  {
    name: "Joshua Mugisha",
    role: "Co-Founder & Co-CEO",
    image: image, // replace with actual image path
  },
  {
    name: "Don Marume",
    role: "Co-Founder & Co-CEO",
    image: reponse,
  },
  {
    name: "Kevin Hirwa",
    role: "Chief Technology Officer",
    image: mamakaba,
  },
  {
    name: "Charles Boromeon",
    role: "Head of Enterprise & Cloud Platform",
    image: image,
  },
  {
    name: "Eric IGIRANEZA",
    role: "Head of Communication and Customer service",
    image: image,
  },
  {
    name: "Jane Abebi",
    role: "Chief Financial Officer",
    image: image,
  },
];

// TeamCard component for each member
const TeamCard = ({ name, role, image }) => {
  return (
    <div className="flex flex-col items-center p-4 shadow-lg rounded-lg">
      <div className="">
        <img
          src={image}
          alt={name}
          className="w-32 h-32 rounded-full object-cover border-4 border-white z-10"
        />
      </div>
      <h3 className="mt-4 text-xl font-bold">{name}</h3>
      <p className="text-sm text-gray-500">{role}</p>
    </div>
  );
};

const LeadershipTeam = () => {
  return (
    <div className="py-10 bg-gray-100">
      <h2 className="text-center text-3xl font-bold mb-8">
        Our Leadership Team
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {team.map((member, index) => (
          <TeamCard
            key={index}
            name={member.name}
            role={member.role}
            image={member.image}
          />
        ))}
      </div>
    </div>
  );
};

export default LeadershipTeam;
